<div class="d-flex flex-column w-100 h-100 wrapper">
  <div class="d-flex flex-column bg-white w-100 align-items-center">
    <div class="d-flex w-100 align-items-center justify-content-between p-3">
      <h4 class="m-0 text-crm">{{ 'edit_widget' | translate }}</h4>
      @if (baseService.isMobile) {
        <app-button (onChangeClick)="onNoClick()" [btnType]="'icon'" matTooltip="{{ 'close' | translate }}">
          <app-icon>close</app-icon>
        </app-button>
      }
    </div>
    <mat-divider class="w-100"></mat-divider>
  </div>
  <div
    class="d-flex w-100 h-100 px-4 py-3 gap-3 overflow-auto crm-scroll"
    [ngClass]="{ 'flex-column': baseService.isMobile }"
  >
    <div class="d-flex flex-column gap-2 w-100">
      <mat-card class="p-3 rounded-2 shadow-none">
        <mat-card class="shadow-sm border rounded-2 gap-3">
          <mat-card-header class="card-header p-2"
            ><span class="fw-bold">{{ 'widget_name' | translate }}</span></mat-card-header
          >
          <mat-card-content class="d-flex flex-column w-100 justify-content-center">
            <app-text-field
              class="w-100"
              (focusout)="additionalSettingsForm.controls.widget_name.markAsTouched()"
              [placeholder]="'Name'"
              [formControl]="additionalSettingsForm.controls.widget_name"
            >
            </app-text-field>
            @if (
              additionalSettingsForm?.controls?.widget_name?.touched &&
              additionalSettingsForm?.controls?.widget_name?.invalid
            ) {
              <mat-hint class="text-danger">
                @if (additionalSettingsForm?.controls?.widget_name?.errors?.['required']) {
                  {{ 'field_cannot_be_empty' | translate }}
                }
              </mat-hint>
            }
          </mat-card-content>
        </mat-card>
      </mat-card>
      <mat-card class="p-3 rounded-2 shadow-none">
        <mat-card class="shadow-sm border rounded-2 gap-3">
          <mat-card-header class="card-header p-2"
            ><span class="fw-bold">{{ 'widget_type' | translate }}</span></mat-card-header
          >
          <mat-card-content class="d-flex flex-column w-100 justify-content-center">
            <app-dropdown
              class="w-100"
              [items]="widget_types"
              bindLabel="name"
              bindValue="value"
              [closeOnSelect]="true"
              (focusout)="additionalSettingsForm.controls.widget_name.markAsTouched()"
              [formControl]="additionalSettingsForm.controls.widget_type"
              (onValueChange)="setWidgetType($event)"
            >
            </app-dropdown>
            @if (
              additionalSettingsForm?.controls?.widget_type?.touched &&
              additionalSettingsForm?.controls?.widget_type?.invalid
            ) {
              <mat-hint class="text-danger">
                @if (additionalSettingsForm?.controls?.widget_type?.errors?.['required']) {
                  {{ 'field_cannot_be_empty' | translate }}
                }
              </mat-hint>
            }
          </mat-card-content>
        </mat-card>
      </mat-card>
      <mat-card class="p-3 rounded-2 shadow-none gap-3">
        <mat-card class="shadow-sm border rounded-2 gap-3">
          <mat-card-header class="card-header p-2"
            ><span class="fw-bold">{{ 'embed_code' | translate }}</span></mat-card-header
          >
          <mat-card-content class="code d-flex flex-column w-100 justify-content-center align-items-center">
            <app-textarea [formControl]="codeForm.controls.code" [readonly]="true" class="w-100"></app-textarea>
            <app-button (onChangeClick)="copyToClipboard()">{{ 'copy_to_clipboard' | translate }}</app-button>
          </mat-card-content>
        </mat-card>
        <!--        <mat-card class="shadow-sm border rounded-2 gap-3">-->
        <!--          <mat-card-header class="card-header p-2"><span class="fw-bold">Підключена колонка</span></mat-card-header>-->
        <!--          <mat-card-content>-->
        <!--            <app-dropdown-->
        <!--              class="w-100"-->
        <!--              bindLabel="name"-->
        <!--              bindValue="id"-->
        <!--              [items]="allowedFunnels"-->
        <!--              [closeOnSelect]="true"-->
        <!--            ></app-dropdown>-->
        <!--          </mat-card-content>-->
        <!--        </mat-card>-->
      </mat-card>
    </div>
    <div class="d-flex settings flex-column gap-3" [ngClass]="{ 'w-100': baseService.isMobile }">
      <mat-card class="p-3 rounded-2 shadow-none gap-3">
        <mat-card class="shadow-none">
          <mat-card-header class="p-2 ps-0"
            ><span class="fw-bold">{{ 'general_appearance' | translate }}:</span></mat-card-header
          >
          <mat-card-content
            class="rounded-2 p-3 d-flex flex-column w-100 justify-content-center align-items-center wrapper"
          >
            <div class="d-flex w-100 h-100 justify-content-center align-items-center preview">
              <app-icon
                class="icon-mdmd rounded-circle d-flex justify-content-center align-items-center"
                [ngStyle]="{ 'background-color': backgroundColor, color: iconColor }"
                >chat
              </app-icon>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card class="shadow-none">
          <mat-card-content class="wrapper rounded-2">
            <div class="d-flex gap-3 w-100 flex-wrap justify-content-center align-items-center">
              <div class="d-flex gap-2 align-items-center justify-content-center flex-column">
                <span>{{ 'background_color' | translate }}</span>
                <app-text-field
                  [type]="'color'"
                  [formControl]="iconColorForm.controls.icon_background"
                  (onValueChange)="setBackgroundColor($event)"
                ></app-text-field>
              </div>
              <div class="d-flex gap-2 align-items-center justify-content-center flex-column">
                <span>{{ 'icon_color' | translate }}</span>
                <app-text-field
                  [type]="'color'"
                  [formControl]="iconColorForm.controls.icon_color"
                  (onValueChange)="setColor($event)"
                ></app-text-field>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card class="shadow-none">
          <mat-card-header class="p-2 ps-0"
            ><span class="fw-bold">{{ 'choose_position' | translate }}:</span></mat-card-header
          >
          <mat-card-content
            class="rounded-2 p-3 d-flex flex-column w-100 justify-content-center align-items-center wrapper"
          >
            <div class="positions">
              @for (position of positions; track position) {
                <div>
                  <mat-card
                    [ngClass]="{ 'active-position': selectedPosition === position.value }"
                    (click)="setPosition(position.value)"
                    class="grid-item rounded-2"
                  >
                    <mat-card-content>
                      <app-icon>{{ position.icon }}</app-icon>
                    </mat-card-content>
                  </mat-card>
                </div>
              }
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card class="shadow-none">
          <mat-card-header class="p-2 ps-0"
            ><span class="fw-bold">{{ 'show_time' | translate }}:</span></mat-card-header
          >
          <mat-card-content class="rounded-2 p-3 d-flex flex-column w-100 justify-content-center wrapper">
            <fieldset>
              <div class="d-flex align-items-center gap-2">
                <input
                  (click)="disableTimeOut()"
                  [formControl]="additionalSettingsForm.controls.time"
                  type="radio"
                  id="input1"
                  name="time"
                  value="now"
                />
                <label for="input1">{{ 'immediately' | translate }}</label>
              </div>
              <div class="d-flex flex-wrap align-items-center gap-2">
                <input
                  [formControl]="additionalSettingsForm.controls.is_timeout"
                  type="radio"
                  id="input2"
                  name="time"
                  [value]="true"
                />
                <label for="input2">{{ 'delay' | translate }}</label>
                <app-dropdown
                  class="w-100"
                  [disabled]="!additionalSettingsForm.controls.is_timeout.value"
                  [items]="time"
                  [closeOnSelect]="true"
                  [bindValue]="'value'"
                  [bindLabel]="'name'"
                  [formControl]="additionalSettingsForm.controls.time"
                >
                </app-dropdown>
              </div>
            </fieldset>
          </mat-card-content>
        </mat-card>
        @if (additionalSettingsForm.controls.widget_type.value !== WIDGET_TYPES.CHAT) {
          <mat-card class="shadow-none">
            <mat-card-header class="p-2 ps-0"
              ><span class="fw-bold">{{ 'form' | translate }}:</span></mat-card-header
            >
            <mat-card-content
              class="rounded-2 gap-2 p-3 d-flex flex-column w-100 align-items-center justify-content-center wrapper"
            >
              @if (inputs?.length) {
                <div
                  class="d-flex flex-column w-100 gap-2 example-list crm-scroll"
                  cdkDropList
                  cdkDropListOrientation="vertical"
                  (cdkDropListDropped)="drop($event)"
                >
                  @for (input of inputs; track input; let i = $index) {
                    <div class="d-flex w-100 flex-column">
                      <div
                        class="d-flex rounded-2 w-100 p-2 bg-white justify-content-between align-items-center example-box"
                        cdkDrag
                      >
                        <span
                          >{{ input.name }}
                          @if (input.is_required) {
                            <span class="required-star">*</span>
                          }
                        </span>
                        <div class="d-flex justify-content-between align-items-center">
                          <app-button btnType="icon" (onChangeClick)="editInput(i)">
                            <app-icon>edit</app-icon> </app-button
                          ><app-button btnType="icon" (onChangeClick)="deleteInput(i)">
                            <app-icon>delete</app-icon>
                          </app-button>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
              @if (showAddInput) {
                <div
                  class="d-flex position-relative rounded-2 w-100 flex-column bg-white p-3 gap-3 justify-content-center align-items-center"
                >
                  <div class="d-flex w-100 flex-column gap-1">
                    <h6 class="text-crm">{{ 'input_name' | translate }}: <span class="required-star">*</span></h6>
                    <app-text-field
                      class="w-100"
                      [formControl]="inputForm.controls.name"
                      (focusout)="inputForm.controls.name.markAsTouched()"
                    ></app-text-field>
                    @if (inputForm.controls.name.touched && inputForm.controls.name.invalid) {
                      <mat-hint class="text-danger">
                        @if (inputForm.controls.name.errors?.['required']) {
                          {{ 'field_cannot_be_empty' | translate }}
                        }
                      </mat-hint>
                    }
                  </div>
                  <div class="d-flex w-100 flex-column gap-1">
                    <h6 class="text-crm">{{ 'type' | translate }}: <span class="required-star">*</span></h6>
                    <app-dropdown
                      class="w-100"
                      [items]="types"
                      [bindLabel]="'name'"
                      [formControl]="inputForm.controls.type"
                      (focusout)="inputForm.controls.type.markAsTouched()"
                    ></app-dropdown>
                    @if (inputForm.controls.type.touched && inputForm.controls.type.invalid) {
                      <mat-hint class="text-danger">
                        @if (inputForm.controls.type.errors?.['required']) {
                          {{ 'field_cannot_be_empty' | translate }}
                        }
                      </mat-hint>
                    }
                  </div>
                  <div class="d-flex w-100 flex-column gap-1">
                    <h6 class="text-crm">{{ 'placeholder' | translate }}:</h6>
                    <app-text-field class="w-100" [formControl]="inputForm.controls.placeholder"></app-text-field>
                  </div>
                  <div class="d-flex w-100 flex-column gap-1">
                    <app-checkbox class="w-100" [formControl]="inputForm.controls.is_required">{{
                      'required' | translate
                    }}</app-checkbox>
                  </div>
                  <div class="d-flex flex-wrap-reverse w-100 justify-content-center gap-2 align-items-center">
                    <app-button [customClass]="'bg-danger'" (onChangeClick)="closeAddInput()">{{
                      'close' | translate
                    }}</app-button>
                    @if (!isEditInput) {
                      <app-button (onChangeClick)="saveInput()">{{ 'add' | translate }}</app-button>
                    }
                    @if (isEditInput) {
                      <app-button (onChangeClick)="saveEditInput()">{{ 'save' | translate }}</app-button>
                    }
                  </div>
                </div>
              }
              @if (!showAddInput) {
                <app-button btnType="icon" (onChangeClick)="addInput()">
                  <app-icon>add</app-icon>
                </app-button>
              }
            </mat-card-content>
          </mat-card>
        }
        <mat-card class="shadow-none">
          <mat-card-header class="p-2 ps-0"
            ><span class="fw-bold">{{ 'mobile_devices' | translate }}:</span></mat-card-header
          >
          <mat-card-content class="rounded-2 p-3 d-flex flex-column w-100 justify-content-center wrapper">
            <app-checkbox [formControl]="additionalSettingsForm.controls.is_mobile"
              >{{ 'do_not_show' | translate }}
            </app-checkbox>
          </mat-card-content>
        </mat-card>
        <mat-card class="shadow-none">
          <mat-card-header class="p-2 ps-0"
            ><span class="fw-bold">{{ 'created_in_jecrm' | translate }}:</span></mat-card-header
          >
          <mat-card-content class="rounded-2 p-3 d-flex flex-column w-100 justify-content-center wrapper">
            <app-checkbox [formControl]="additionalSettingsForm.controls.is_jecrm"
              >{{ 'show_caption' | translate }}
            </app-checkbox>
          </mat-card-content>
        </mat-card>
      </mat-card>
    </div>
  </div>
  <div class="bg-white d-flex flex-column">
    <mat-divider class="w-100"></mat-divider>
    <div class="d-flex w-100 justify-content-center align-items-center gap-2 p-3">
      <app-button [customClass]="'bg-danger'" btnType="cancel" (onChangeClick)="onNoClick()"
        >{{ 'cancel' | translate }}
      </app-button>
      <div class="flex-fill"></div>
      <app-button (onChangeClick)="save()">{{ 'save' | translate }}</app-button>
    </div>
  </div>
</div>
